// import {EmbryoService} from 'src/app/Services/Embryo.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ConfirmationPopup',
  templateUrl: './ConfirmationPopup.component.html',
  styleUrls: ['./ConfirmationPopup.component.scss'],
})
export class ConfirmationPopupComponent implements OnInit {
  message: string = '';
  lang: any;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    private translate: TranslateService,
    // private  embryoService: EmbryoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // embryoService.emitLang.subscribe((lang: string) => {
    //     translate.setDefaultLang(lang);
    //     this.lang = lang;
    // });
  }

  ngOnInit() {
    this.lang = localStorage.getItem('lang');
    this.translate.setDefaultLang(this.lang);
  }
}
